var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "interface-two" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "interface-two-container",
        attrs: {
          "element-loading-text": "拼命加载中",
          "element-loading-spinner": "el-icon-loading",
        },
      },
      _vm._l(_vm.goodsList, function (goods, index) {
        return _c("div", { key: index, staticClass: "goods-item" }, [
          _c("img", {
            staticClass: "goods-img",
            attrs: { src: goods.image },
            on: {
              error: function ($event) {
                return _vm.imgError(index)
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "goods-info" }, [
            _c("div", { staticClass: "title" }, [_vm._v(_vm._s(goods.name))]),
            _vm._v(" "),
            _c("div", { staticClass: "price" }, [
              _c("div", { staticClass: "price-num" }, [
                _vm._m(0, true),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(goods.otPrice))]),
              ]),
              _vm._v(" "),
              _vm._m(1, true),
            ]),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src: require("../../../../../../../../assets/imgs/jindou.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cart" }, [
      _c("img", {
        attrs: {
          src: require("../../../../../../../../assets//imgs/cart.svg"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }